import React, { useState } from 'react';

const getInitials = (user = {}) => {
  const first = user.first_name || user.firstName || '';
  const last = user.last_name || user.lastName || '';
  const name = user.name || user.full_name || user.fullName || '';

  if (first || last) {
    return `${first?.[0] || ''}${last?.[0] || ''}`.toUpperCase() || 'U';
  }

  if (name) {
    return name
      .split(' ')
      .filter(Boolean)
      .map((part) => part[0])
      .join('')
      .slice(0, 2)
      .toUpperCase();
  }

  return 'U';
};

const getPhotoUrl = (user = {}) => {
  return (
    user.profile_image ||
    user.profile_photo ||
    user.profilePhoto ||
    user.avatar_url ||
    user.photo_url ||
    user.photoUrl ||
    ''
  );
};

const SIZE_CLASSES = {
  xs: 'w-6 h-6 text-[10px]',
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-14 h-14 text-lg',
  executive: 'w-16 h-16 text-xl',
  xl: 'w-20 h-20 text-2xl',
};

export default function OfficerAvatar({
  user,
  size = 'sm',
  className = '',
  showRing = true,
}) {
  const [imageFailed, setImageFailed] = useState(false);

  const photoUrl = getPhotoUrl(user);
  const initials = getInitials(user);
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.sm;

  const baseClass = [
    sizeClass,
    'rounded-full shrink-0 overflow-hidden flex items-center justify-center',
    showRing ? 'border border-blue-500/30' : '',
    'bg-blue-500/20 text-blue-400 font-bold',
    className,
  ].filter(Boolean).join(' ');

  if (photoUrl && !imageFailed) {
    return (
      <img
        src={photoUrl}
        alt={`${user?.first_name || user?.firstName || user?.name || 'Officer'} profile`}
        className={`${baseClass} object-cover`}
        onError={() => setImageFailed(true)}
        loading="lazy"
      />
    );
  }

  return (
    <div className={baseClass} title="No profile photo">
      <span>{initials}</span>
    </div>
  );
}
